import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ElementRef
} from '@angular/core';
// import { AngularFirestore } from '@angular/fire/firestore';
import {
  ActivatedRoute,
  Router,
} from '@angular/router';

import { DataService } from 'src/app/services/data.service';
import * as moment from 'moment';

// import { OrderDetailPage } from 'src/app/pages/order-detail/order-detail.page';
// import { DbService } from 'src/app/services/db.service';
import {
  ModalController,
  Platform,
} from '@ionic/angular';

@Component({
  selector: 'app-orderss',
  templateUrl: './orderss.component.html',
  styleUrls: ['./orderss.component.scss'],
})
export class OrderssComponent implements OnInit {
  // page_no = 0;

  @Input() orders_list;
  @Input() sales_type;
  // ismobile;
  // @Input() order_detail;
  order_sum = true;
  hidelist = true;
  check_box = false;
  order_status;
  get_order_status: any = {
    dropdown_api: 'Order Status'
  };

  options_value;
  @ViewChild('scrollMe') scrollMe!: ElementRef;
  // no_info = false;
  // items: Observable<any[]>;
  @Output() order_data: EventEmitter<any[]> = new EventEmitter();
  // item : any;
  constructor(public db: DataService, private platform: Platform, private router: Router, private modalCtrl: ModalController, private route: ActivatedRoute) {

  }


  ngOnInit() {
    this.db.scroll_top = true;
    // this.order_status = this.get_order_status.dropdown_api;
    // console.log('this.order_status',this.order_status)
  }

  order_list(item) {
    this.db.orders_list = false;
    this.passorderdata(item);
  }

  passorderdata(item) {
    this.order_data.emit(item);
  }

  get_dropdown(data) {

    if (!data.options) {
      this.db.get_doctype_datas(data.dropdown_api).subscribe(res => {
        data.options = res.data;
        this.options_value = data.options
      })
    }

  }

  value_changed(eve) {
    //  console.log(eve)
    if (eve.detail.value) {
      let value = eve.detail.value;
      let d = this.options_value.find(r => r.name == value);
      d ? this.order_status = d.name : null;
      // this.get_order_status.dropdown_api = this.order_status 
    }

  }

  // check_true(){
  //     this.check_box = true
  // }

  onScroll(event: any) {
    // console.log(event);
    // if (this.db.p_loadMoreData && !this.db.searchText) {

    //   if (event.target.scrollTop <= 100) {
    //     this.db.scroll_top = true;
    //   } else {
    //     this.db.scroll_top = false;
    //   }
      // if(event.target.scrollBottom <= 100){
      //    
      // }
      if ( this.db.p_loadMoreData && event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
        // this.db.page_no = this.db.page_no + 15;
        this.db.page_no = this.db.page_no + 1;
        console.log(event)
        // if(this.db.active_sales_type == '')
        this.db.active_sales_type == '' ? this.db.pending_orders(this.db.typeOfData, 'order') : this.db.pending_orders(this.db.typeOfData, 'sales');
      }
    // }
  }

}
